<template>
  <el-dialog id="notification" :visible.sync="dialogVisible" class="diglog-card" :title="$t('components.notification')" append-to-body :close-on-click-modal="false" width="509px" @close="close">
    <div v-loading="dialogLoading" class="top-container">
      <div class="tag">UPDATE</div>
      <img id="notification-banner" src="@/assets/img/notification_banner.png" style="width: 231px; height: 66px;">
      <div class="top-txt-container">
        <div class="top-txt-1">
          {{ detailData.title }}
        </div>
        <div class="top-txt-2">{{ detailData.notice_actual_time }}</div>
      </div>
    </div>
    <div>
      <!-- <h2 class="title">Fee Structure Adjustment</h2>
      <div class="time">3 days ago</div> -->
      <p class="txt">{{ detailData.content }}</p>
      <ChannelFee v-if="detailData.type === 1 && detailData.data" :fee-data="JSON.parse(detailData.data)" />

      <!-- 附件列表 -->
      <div v-if="detailData.notice_file_resp_list && detailData.notice_file_resp_list.length > 0" class="attachment-section">
        <div class="attachment-title">{{ $t('no_auth.attachment') }}</div>
        <div class="attachment-list">
          <div v-for="(file, index) in detailData.notice_file_resp_list" :key="index" class="attachment-item">
            <i class="el-icon-document" />
            <span class="file-name">{{ file.file_name }}</span>
            <el-button type="text" class="download-btn" @click="downloadFile(file.file_oss_url, file.file_name)">
              <i class="el-icon-download" />
            </el-button>
          </div>
        </div>
      </div>

    </div>
    <div slot="footer" class="dialog-footer">
      <el-button type="info" class="btn-close" @click="dialogVisible = false">{{ $t('components.close') }}</el-button>
    </div>
  </el-dialog>

</template>
<script>
import { fetchUnreadNotificationCount, fetchNotificationDetail } from '@/api/system/system'
export default {
  name: 'MessageNotification',
  components: {
    ChannelFee: () => import('./ChannelFee.vue')
  },
  data() {
    return {
      dialogVisible: false,
      dialogLoading: false,
      detailData: {}
    }
  },
  methods: {
    showModal(row) {
      this.dialogVisible = true
      this.getContent({ user_detail_no: row.user_detail_no })
    },
    getContent(data) {
      this.dialogLoading = true
      fetchNotificationDetail(data).then(res => {
        this.detailData = res.data
        this.$store.dispatch('user/getUnreadNotificationCount')
        this.$emit('getMessageList')
      }).finally(() => {
        this.dialogLoading = false
      })
    },
    downloadFile(url, fileName) {
      // 创建一个隐藏的a标签来触发下载
      const link = document.createElement('a')
      link.href = url
      link.download = fileName
      link.target = '_blank'
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    },
    close() {
      this.detailData = {}
    }
  }
}
</script>
<style >
#notification {

}
</style>

<style scoped lang="scss">
#notification{
 ::v-deep.el-dialog__body{
    padding-top: 10px;
  }
  .top-container{
    width: 509px;
    position: relative;
    left: -20px;
    height: 167px;
    background: #071D92;

    .tag{
      position: absolute;
      top: 20px;
      left: 20px;
      display: inline-block;
      padding: 5px 10px;
      background: #E2211C;
      border-radius: 15px;
      color: #fff;
      font-size: 12px;
    }
    #notification-banner{
      position: absolute;
      top: 0;
      right: 0;
    }
    .top-txt-container{
      padding: 20px;
      position: absolute;
      left: 0;
      bottom: 0;
      color: #fff;
      .top-txt-1{
        font-size: 22px;
        font-weight: bold;
        white-space: pre-wrap;
        overflow-wrap: break-word;
      }
      .top-txt-2{
        margin-top: 10px;
        font-weight: 400;
        font-size: 12px;
      }
    }
  }
  .title{
    color: #1E1E1E;
    font-size: 20px;
    font-weight: 600;
  }
  .time{
    color: #767676;
    font-size: 12px;
  }
  .txt{
    color: #181818;
    font-size: 12px;
    white-space: pre-wrap;
    overflow-wrap: break-word;
  }
  .attachment-section{
    margin-top: 16px;
    .attachment-title{
      color: #181818;
      font-size: 14px;
      font-weight: 600;
      margin-bottom: 10px;
    }
    .attachment-list{
      display: flex;
      flex-wrap: wrap;
      gap: 10px;
    }
    .attachment-item{
      display: flex;
      align-items: center;
      padding: 8px 12px;
      border: 1px solid #E3E3E3;
      border-radius: 4px;
      background: #FAFAFA;
      max-width: 280px;
      i.el-icon-document{
        font-size: 16px;
        color: #909399;
        margin-right: 8px;
        flex-shrink: 0;
      }
      .file-name{
        color: #181818;
        font-size: 12px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        flex: 1;
      }
      .download-btn{
        margin-left: 8px;
        padding: 0;
        flex-shrink: 0;
        i{
          font-size: 16px;
          color: #409EFF;
        }
      }
    }
  }
.fee-table{
  width: 100%;
  border-collapse:collapse;
  border-spacing: 0;
  table-layout:fixed;
  th{
    background: #F0F0F0;
    color: #000;
    text-align: center;
  }
  td,th{
    border: 1px solid #D6D6D6;
    padding: 10px;
    font-size: 12px;
    text-align: center;
  }
}
  .dialog-footer{
    position: relative;
    left: -20px;
    width: 509px;
    border-top: 1px solid #E3E3E3;
  }
  .btn-close{
    margin: 20px 20px 0 0;
  }

}

</style>
